import { bool, func, string } from "prop-types";
import { observer } from "mobx-react";
import { getDateKey } from "@repo/structure";
import { useEstimateStructure } from "@tools";
import { TimelineVirtualCell } from "./TimelineVirtualCell";
import { TimelineUtilizationCell } from "./TimelineUtilizationCell";
import { TimelineUtilizationChart } from "./TimelineUtilizationChart";
import useStyle from "./TimelineCells.style";

export const TimelineUtilizationCells = observer(({
  workTypeId,
  teamMemberId,
  color,
  fontColor,
  name,
  expandable,
  expanded,
  onExpand,
}) => {
  const classes = useStyle();
  const structure = useEstimateStructure();
  const { useTimelineChart } = structure.settings;

  if(useTimelineChart) {
    return (
      <div className={classes.segment}>
        <TimelineUtilizationChart
          workTypeId={workTypeId}
          teamMemberId={teamMemberId}
          color={color}
          fontColor={fontColor}
          name={name}
          expandable={expandable}
          expanded={expanded}
          onExpand={onExpand}
        />
      </div>
    )
  }

  const utilization = structure.currentTimeline?.getUtilization(workTypeId, teamMemberId);

  return (
    <div className={classes.segment}>
      {
        utilization.map((month) => (
          <TimelineVirtualCell
            key={getDateKey(month.startDate)}
            month={month}
          >
            <TimelineUtilizationCell
              monthUtilization={month}
              bold={!teamMemberId}
              entityName={name}
            />
          </TimelineVirtualCell>
        ))
      }
    </div>
  );
});

TimelineUtilizationCells.propTypes = {
  workTypeId: string.isRequired,
  teamMemberId: string,
  color: string,
  fontColor: string,
  name: string,
  expandable: bool,
  expanded: bool,
  onExpand: func,
};
